import React, { useState } from 'react';
import { Download, Users, MapPin, BarChart3, Ticket, Sparkles, Loader2, Check } from 'lucide-react';
import { motion } from 'framer-motion';
import { authFetch, API } from '../../utils/api';


const EXPORTS = [
  { key: 'users', label: 'Users', desc: 'All active user accounts with stats', icon: Users, endpoint: '/api/admin/export/users' },
  { key: 'sessions', label: 'Surf Sessions', desc: 'All logged surf sessions', icon: BarChart3, endpoint: '/api/admin/export/sessions' },
  { key: 'spots', label: 'Surf Spots', desc: 'Popular + Spitcast + community spots', icon: MapPin, endpoint: '/api/admin/export/spots' },
  { key: 'aura', label: 'Aura Events', desc: 'All aura point transactions', icon: Sparkles, endpoint: '/api/admin/export/aura-events' },
  { key: 'tickets', label: 'Support Tickets', desc: 'All support tickets', icon: Ticket, endpoint: '/api/admin/export/tickets' },
];

export default function AdminDownloads() {
  const [downloading, setDownloading] = useState(null);
  const [done, setDone] = useState(null);

  const handleDownload = async (exp) => {
    setDownloading(exp.key);
    try {
      const res = await fetch(`${API}${exp.endpoint}`);
      if (res.ok) {
        const blob = await res.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `surfswell_${exp.key}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
        setDone(exp.key);
        setTimeout(() => setDone(null), 2000);
      }
    } catch {} finally { setDownloading(null); }
  };

  return (
    <div data-testid="admin-downloads">
      <div className="flex items-center gap-2 mb-4">
        <Download className="w-4 h-4 text-primary/60" />
        <p className="text-xs font-heading font-semibold">Data Exports</p>
      </div>
      <p className="text-[10px] text-muted-foreground/50 mb-4">Download CSV exports of your app data.</p>

      <div className="space-y-2">
        {EXPORTS.map((exp, i) => (
          <motion.div
            key={exp.key}
            initial={{ opacity: 0, y: 4 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: i * 0.04 }}
            className="bg-white/[0.025] border border-white/5 rounded-xl p-3 flex items-center justify-between"
          >
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-primary/10 rounded-lg flex items-center justify-center">
                <exp.icon className="w-4 h-4 text-primary/70" />
              </div>
              <div>
                <p className="text-xs font-medium text-white">{exp.label}</p>
                <p className="text-[9px] text-muted-foreground/50">{exp.desc}</p>
              </div>
            </div>
            <button
              data-testid={`download-${exp.key}`}
              onClick={() => handleDownload(exp)}
              disabled={downloading === exp.key}
              className="flex items-center gap-1.5 text-[10px] px-3 py-1.5 rounded-lg bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 transition-colors disabled:opacity-40 font-medium"
            >
              {done === exp.key ? (
                <><Check className="w-3 h-3" /> Done</>
              ) : downloading === exp.key ? (
                <><Loader2 className="w-3 h-3 animate-spin" /> Exporting</>
              ) : (
                <><Download className="w-3 h-3" /> CSV</>
              )}
            </button>
          </motion.div>
        ))}
      </div>
    </div>
  );
}
